import React from 'react';
var ChartContext = React.createContext({});
export default ChartContext;
